import { useMemo } from 'react';

import type { SellerProducts } from 'sellDirect/declarations/products';
import { extractSellerProducts } from 'sellDirect/declarations/sellerTransaction';
import { useSellerLead } from 'sellDirect/graphql/SellerLeadContext';
import { useRefetchSellerTransactionProducts } from 'sellDirect/graphql/useSellerTransactionProductsRefetchQueries';

/**
 * Returns product data derived from `sellerTransaction.acquisitionProducts`,
 * `selectedAcquisitionProduct`, and `previouslyEligibleProducts`. All product
 * fields now live on `sellerTransaction`; the legacy `productsExperiences`
 * query is no longer needed.
 */
export const useSellerProducts = () => {
  const { sellerTransaction, loading } = useSellerLead();

  const refetch = useRefetchSellerTransactionProducts();

  const sellerProducts = useMemo<SellerProducts>(
    () => extractSellerProducts(sellerTransaction),
    [sellerTransaction],
  );

  return {
    sellerProducts,
    loading,
    refetch,
  };
};
